import { Record } from 'immutable';

export const ACCOUNTS_BALANCES_HISTORY_REDUCER_KEY = 'accountsBalancesHistoryStore';

export const mkAccountsBalancesHistory = Record({
  columns: undefined,
  columnType: undefined,
  endOn: undefined,
  rowType: undefined,
  rows: undefined,
  startOn: undefined,
  timestep: undefined,
});
